import { SxProps } from "@mui/material";

export const sxFormLabel: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#4C4C4C',
  "&.Mui-focused": {
    color: "#4C4C4C",
  },
  marginBottom: '20px',
  '@media (max-width: 475px)': {
    width: '100%'
  }
}

export const sxRadioGroup: SxProps = {
  gap: '40px',
  '@media (max-width: 475px)': {
    gap: 'unset',
    justifyContent: 'space-between',
    width: '100%'
  }
}

export const sxTable: SxProps = {
  borderRadius: '10px',
  width: '100%',
  '@media (max-width: 1135px)': {
      width: '60vw'
  },
  '@media (max-width: 1055px)': {
      width: '55vw'
  },
  '@media (max-width: 920px)': {
      width: '50vw'
  },
  '@media (max-width: 899px)': {
      width: '90vw'
  },
  '@media (max-width: 425px)': {
      width: '85vw'
  }
}